function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1865.71,-1700.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17188,0,0,1.17187,1865.71,1700.4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.555,-0.832,0.832,0.555,-237.641,271.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.592,
    y: 350.25,
    width: 116.399,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.555,-0.832,0.832,0.555,-34.251,495.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.925,
    y: 272.417,
    width: 116.399,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707,-0.707,0.707,0.707,-176.932,249.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.125,
    y: 295.214,
    width: 15,
    height: 86.156,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.555,-0.832,0.832,0.555,-135.946,383.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.258,
    y: 311.333,
    width: 116.4,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707,-0.707,0.707,0.707,-103.82,348.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.792,
    y: 256.297,
    width: 15,
    height: 86.157,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707,-0.707,0.707,0.707,-117.178,160.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 214.042,
    width: 86.156,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707,-0.707,0.707,0.707,56.564,346.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.034,
    y: 97.292,
    width: 86.156,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707,-0.707,0.707,0.707,-94.381,215.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.111,
    y: 178.464,
    width: 15,
    height: 86.156,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.555,-0.832,0.832,0.555,-38.812,331.643)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.245,
    y: 194.583,
    width: 116.4,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 341.319,
    y: 136.208,
    width: 53.917,
    height: 15,
    style: {
      fill: "rgb(243,205,81)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M504.5,467L489.5,467L497,482L497,504.5C497,508.642 500.357,512 504.5,512C508.643,512 512,508.642 512,504.5L512,474.5C512,470.358 508.643,467 504.5,467Z",
    style: {
      fill: "rgb(206,206,206)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5,467L45,467L45,7.5C45,3.358 41.643,0 37.5,0L7.5,0C3.357,0 0,3.358 0,7.5C0,11.642 3.357,15 7.5,15L30,15L30,38.917L22.5,38.917C18.357,38.917 15,42.275 15,46.417C15,50.559 18.357,53.917 22.5,53.917L30,53.917L30,77.834L7.5,77.834C3.357,77.834 0,81.192 0,85.334C0,89.476 3.357,92.834 7.5,92.834L30,92.834L30,116.751L22.5,116.751C18.357,116.751 15,120.109 15,124.251C15,128.393 18.357,131.751 22.5,131.751L30,131.751L30,155.668L7.5,155.668C3.357,155.668 0,159.026 0,163.168C0,167.31 3.357,170.668 7.5,170.668L30,170.668L30,194.585L22.5,194.585C18.357,194.585 15,197.943 15,202.085C15,206.227 18.357,209.585 22.5,209.585L30,209.585L30,233.5L7.5,233.5C3.357,233.5 0,236.858 0,241C0,245.142 3.357,248.5 7.5,248.5L30,248.5L30,272.417L22.5,272.417C18.357,272.417 15,275.775 15,279.917C15,284.059 18.357,287.417 22.5,287.417L30,287.417L30,311.334L7.5,311.334C3.357,311.334 0,314.692 0,318.834C0,322.976 3.357,326.334 7.5,326.334L30,326.334L30,350.251L22.5,350.251C18.357,350.251 15,353.609 15,357.751C15,361.893 18.357,365.251 22.5,365.251L30,365.251L30,389.168L7.5,389.168C3.357,389.168 0,392.526 0,396.668C0,400.81 3.357,404.168 7.5,404.168L30,404.168L30,428.085L22.5,428.085C18.357,428.085 15,431.443 15,435.585C15,439.727 18.357,443.085 22.5,443.085L30,443.085L30,467L7.5,467C3.357,467 0,470.358 0,474.5C0,478.642 3.357,482 7.5,482L30,482L30,504.5C30,508.642 33.357,512 37.5,512C41.643,512 45,508.642 45,504.5L45,482L68.917,482L68.917,504.5C68.917,508.642 72.274,512 76.417,512C80.56,512 83.917,508.642 83.917,504.5L83.917,482L107.833,482L107.833,504.5C107.833,508.642 111.19,512 115.333,512C119.476,512 122.833,508.642 122.833,504.5L122.833,482L146.75,482L146.75,504.5C146.75,508.642 150.107,512 154.25,512C158.393,512 161.75,508.642 161.75,504.5L161.75,482L185.667,482L185.667,504.5C185.667,508.642 189.024,512 193.167,512C197.31,512 200.667,508.642 200.667,504.5L200.667,482L224.583,482L224.583,504.5C224.583,508.642 227.94,512 232.083,512C236.226,512 239.583,508.642 239.583,504.5L239.583,482L263.5,482L263.5,504.5C263.5,508.642 266.857,512 271,512C275.143,512 278.5,508.642 278.5,504.5L278.5,482L302.417,482L302.417,504.5C302.417,508.642 305.774,512 309.917,512C314.06,512 317.417,508.642 317.417,504.5L317.417,482L341.333,482L341.333,504.5C341.333,508.642 344.69,512 348.833,512C352.976,512 356.333,508.642 356.333,504.5L356.333,482L380.25,482L380.25,504.5C380.25,508.642 383.607,512 387.75,512C391.893,512 395.25,508.642 395.25,504.5L395.25,482L419.167,482L419.167,504.5C419.167,508.642 422.524,512 426.667,512C430.81,512 434.167,508.642 434.167,504.5L434.167,482L458.083,482L458.083,504.5C458.083,508.642 461.44,512 465.583,512C469.726,512 473.083,508.642 473.083,504.5L473.083,482L497,482L497,474.5C497,470.358 493.643,467 489.5,467Z",
    style: {
      fill: "rgb(206,206,206)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.875,
    cy: 416.125,
    r: 19.458,
    style: {
      fill: "rgb(200,10,152)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.708,
    cy: 299.375,
    r: 19.458,
    style: {
      fill: "rgb(240,0,180)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.542,
    cy: 377.208,
    r: 19.458,
    style: {
      fill: "rgb(200,10,152)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.208,
    cy: 338.292,
    r: 19.458,
    style: {
      fill: "rgb(200,10,152)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.042,
    cy: 221.542,
    r: 19.458,
    style: {
      fill: "rgb(240,0,180)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.375,
    cy: 260.458,
    r: 19.458,
    style: {
      fill: "rgb(240,0,180)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.861,
    cy: 260.458,
    r: 19.458,
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.695,
    cy: 182.625,
    r: 19.458,
    style: {
      fill: "rgb(2,219,140)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.528,
    cy: 260.458,
    r: 19.458,
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.195,
    cy: 143.708,
    r: 19.458,
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.028,
    cy: 65.875,
    r: 19.458,
    style: {
      fill: "rgb(2,219,140)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.361,
    cy: 143.708,
    r: 19.458,
    style: {
      fill: "rgb(2,219,140)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.acfdc1736b84a8b67d8b9835c98d2a76.svg";
export { ForwardRef as ReactComponent };